<template>
  <div class="login-moudle">
    <template v-if="!$store.state.loginState">
      <div class="title d-flex j-center" :class="{'home-title': home}">
        <p :class="{active: loginType === 1}" @click="loginType = 1">用户登录</p>
        <p :class="{active: loginType === 2}" @click="loginType = 2">快捷登录</p>
      </div>
      <div class="box">
        <div class="item d-flex a-center">
          <div class="icon" v-if="home">
            <img src="@/assets/img/username-icon.png" alt="">
          </div>
          <input v-model="mobile" placeholder="请输入手机号" />
        </div>
        <template v-if="loginType === 1">
          <div class="item d-flex a-center">
            <div class="icon" v-if="home">
              <img src="@/assets/img/pwd-icon.png" alt="">
            </div>
            <input type="password" v-model="pwd" placeholder="请输入密码" />
          </div>
          <div class="item d-flex a-center">
            <div class="icon" v-if="home">
              <img src="@/assets/img/pwd-icon.png" alt="">
            </div>
            <input v-model="verifyCode" maxlength="6" placeholder="请输入验证码" />
            <img :src="imgCode" alt="" v-loading="loading" class="verify-code" @click="getImgCode">
          </div>
        </template>
        <div class="item d-flex a-center" v-else>
          <div class="icon" v-if="home">
            <img src="@/assets/img/pwd-icon.png" alt="">
          </div>
          <input type="text" v-model="code" placeholder="请输入验证码" style="padding-right: 0;" />
          <button class="common-btn" :style="{ background: get_code_back_color }" @click="huoquphonecode">{{get_code_text}}</button>
        </div>
        <button class="mix-btn" v-loading="loginLoading" @click="login">登录</button>
      </div>
      <div class="imgcode d-flex j-center a-center" v-if="showImgCode">
        <div class="imgcodecontent">
          <div class="imgcodetitle">请输入图形验证码</div>
          <div class="input input1 d-flex a-center">
            <input v-model="verifyCode1" maxlength="6" placeholder="输入验证码" />
            <img class="iiimg" v-loading="loading" @click="getImgCode" :src="imgCode1" />
          </div>
          <div class="imgcodebtn d-flex a-center j-center">
            <div class="qx" @click="showImgCode = false">取消</div>
            <div class="qd" @click="getPhoneCode">确定</div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="usertop d-flex a-center j-center" v-loading="userimgloading" element-loading-text="正在上传...">
        <img class="userimg" v-if="$store.state.userInfo.userPic"
          :src="$utils.imgUrl + $store.state.userInfo.userPic" />
        <img class="userimg" v-else src="../../assets/img/no-headImg.jpg" />
        <div class="usertopright">
          <div class="username">{{ $store.state.userInfo.personName }}</div>
          <div>
            <el-upload name="userPic" :show-file-list="false" :action="$utils.baseURL + $utils.userImgUpload"
              :headers="headers" :limit="1" :before-upload="filebefore" :on-success="filesuccess"
              :on-error="fileerror">
              <div class="uploadbtn">上传头像</div>
            </el-upload>
          </div>
        </div>
      </div>
      <!-- <div class="usera" @click="inwlxy" v-if="$store.state.userInfo && $store.state.userInfo.positionLevelId > '1' && $store.state.userInfo.positionLevelId < '7'">登录至中国干部网络学院</div> -->
      <div class="infobox">
        <div class="userinfoitem d-flex a-center">
          <div class="itemleft">民&ensp;&ensp;&ensp;&ensp;族:</div>
          <div class="itemright">{{ $store.state.userInfo.nationName }}</div>
        </div>
        <div class="userinfoitem d-flex a-center">
          <div class="itemleft">性&ensp;&ensp;&ensp;&ensp;别:</div>
          <div class="itemright">{{ $store.state.userInfo.gender === '0' ? '男' : '女' }}</div>
        </div>
        <div class="userinfoitem d-flex a-center">
          <div class="itemleft">职&ensp;&ensp;&ensp;&ensp;级:</div>
          <div class="itemright">{{ $store.state.userInfo.positionLevelName }}</div>
        </div>
        <div class="userinfoitem d-flex a-center">
          <div class="itemleft">工作单位:</div>
          <div class="itemright row1">{{ $store.state.userInfo.organName }}</div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    home: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      headers: {
        "Authorization": this.$store.state.token
      },
      loginType: 1,
      mobile: '',
      pwd: '',
      verifyCode: '',
      verifyCode1: '',
      code: '',
      imgCode: '',
      code_id: '',
      imgcode1: '',
      loading: false,
      loginLoading: false,
      showImgCode: false,
      smsid: '',
      get_code_text: "发送验证码",
      get_code_is_waiting: false,
      get_code_back_color: "#E10019",
      Timer: null,
      userimgloading: false
    }
  },
  created() {
    if (this.$utils.getItem('webtoken')) {
      this.getUserInfo()
    } else {
      this.getImgCode()
      this.loading = false
      this.$store.commit('setLoginState', false)
    }
  },
  methods: {
    getImgCode() {
      this.loading = true
      this.$api.login.captcha().then((res) => {
        this.loading = false
        if (res.code === 'SUCCESS') {
          this.code_id = res.data.id
          this.imgCode = this.$utils.baseURL + res.data.captcha_image
          this.imgCode1 = this.$utils.baseURL + res.data.captcha_image
        }
      })
    },
    huoquphonecode() {
      if (!this.mobile) {
        this.$message.warning("请输入手机号")
      } else if (this.mobile.length != 11) {
        this.$message.warning("手机号码为11位数字")
      } else {
        this.showImgCode = true
        this.getImgCode()
      }
    },
    getPhoneCode() {
      if (this.get_code_is_waiting) {
        return;
      }
      if (!this.verifyCode1) {
        this.$message.warning('请输入图形验证码！')
      } else {
        this.get_code_text = "发送中...";
        this.$api.login.request_sms_code({
          captcha: this.verifyCode1,
          captcha_session_id: this.code_id,
          phone_number: this.mobile
        }).then((res) => {
          if (res.code == 'SUCCESS') {
            this.get_code_is_waiting = true;
						this.get_code_back_color = "#B7BECC";
            this.setTimer()
            this.smsid = res.data.id
          } else {
            var msg = res.message
            if ('手机号码尚未注册' == msg) {
              msg = '手机号码不存在，请联系单位联络员在陕西干部教育培训管理系统里核对手机号码！'
            }
            this.$message.warning('warning', msg)
          }
          this.showImgCode = false
        })
      }
    },
    setTimer() {
      let holdTime = 60;
      this.get_code_text = "重新获取(60s)";
      this.Timer = setInterval(() => {
        if (holdTime <= 0) {
          this.get_code_is_waiting = false;
          this.get_code_text = "获取验证码";
          this.get_code_back_color = "#E10019";
          clearInterval(this.Timer);
          return;
        }
        this.get_code_text = "重新获取(" + holdTime + "s)";
        holdTime--;
      }, 1000);
    },
    login() {
      if (this.loginType === 1) {
        if (!this.mobile) {
          this.$message.warning("请输入手机号")
        } else if (!this.pwd) {
          this.$message.warning("请输入密码")
        } else if (!this.verifyCode) {
          this.$message.warning("请输入验证码")
        } else {
          this.loginLoading = true
          this.$api.login.userLogin({
            captcha_session_id: this.code_id,
            captcha: this.verifyCode,
            username: this.mobile,
            password: this.pwd,
            expires: 432000
          }).then((res) => {
            this.loginLoading = false
            if (res.code === "SUCCESS") {
              this.$message.success('登录成功！')
              this.$store.commit('setLoginTip', false)
              this.setData(res.data)
            } else {
              this.$message.warning(res.message)
              this.getImgCode()
            }
          })
        }
      } else {
        if (!this.mobile) {
          this.$message.warning("请输入手机号")
        } else if (!this.code) {
          this.$message.warning("请输入手机验证码")
        } else {
          this.loginLoading = true
          this.$api.login.smscode_login({
            captcha: this.code,
            captcha_session_id: this.smsid,
            phone_number: this.mobile,
            expires: 432000
          }).then((res) => {
            this.loginLoading = false
            if (res.code === "SUCCESS") {
              this.$message.success('登录成功！')
              this.$store.commit('setLoginTip', false)
              this.setData(res.data)
            } else {
              this.$message.warning(res.message)
              this.getImgCode()
            }
          })
        }
      }
    },
    setData(data) {
      this.$store.commit('setLoginContent', data.authorization.id)
      this.$store.commit('setLoginPhone', this.mobile)
      this.$api.login.loginSuccess({
        mobilePhone: data.user.mobile,
        loginType: "0",//0：电脑端 1：手机端
        userType: "0"
      }).then((res) => {

      })
      this.getUserInfo(true)
    },
    getUserInfo(bool) {
      this.$api.login.getSessionPerson().then((res) => {
        if (res.obj === null) {
          this.$store.commit('setLoginState', false)
          this.$store.commit('exitLogin')
        } else {
          this.$store.commit('setLoginState', true)
          this.$store.commit('setUserInfo', res.obj)
          if(bool){
            if(res.obj.personType === '1'){
              this.$store.commit('setPersonType', 'student')
              this.$router.replace('/learning/index')
            }else{
              this.$store.commit('setPersonType', 'teacher')
              this.$router.replace('/teacher')
            }
          }
        }
      })
    },
    filebefore() {
      this.userimgloading = true
    },
    filesuccess(uploadFile) {
      this.userimgloading = false
      if (uploadFile.res === 1) {
        this.$message.success(uploadFile.resMsg)
        this.getUserInfo()
      } else {
        this.$message.error(uploadFile.resMsg)
      }
    },
    fileerror() {
      this.userimgloading = false
      this.$message.error('上传失败！')
    },
    inwlxy() {
      window.open(serverConfig.baseURL + `/video_learning/education/zwy/oauth?personId=${this.$store.state.userInfo.personId}&timestamp=${new Date().getTime()}`)
    }
  }
}
</script>
<style lang="scss" scoped>
.login-moudle{
  width: 315px;
  background: #fff;
  position: relative;
  .home-title{
    background: #fff2ef;
  }
  .title{
    padding: 30px 0 20px;
    p{
      margin: 0 30px;
      cursor: pointer;
      padding-bottom: 4px;
    }
    .active{
      border-bottom: 2px solid #E10019;
      color: #E10019;
    }
  }
  .box{
    padding: 25px 20px;
    .item{
      width: 100%;
      height: 40px;
      border-radius: 5px;
      overflow: hidden;
      margin-bottom: 25px;
      background: #e0e0e0;
      .icon{
        background: #E10019;
        width: 44px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
          width: 15px;
        }
      }
      input{
        flex: 1;
        height: 40px;
        padding: 0 15px;
        background: #e0e0e0;
      }
      .verify-code{
        width: 90px;
        height: 40px;
        margin-left: 15px;
      }
      .common-btn{
        height: 30px;
        width: 100px;
        margin-right: 10px;
        font-size: 14px;
      }
    }
  }
  .imgcode {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    .qx {
      background: #f1f1f1;
      margin-right: 0.9375rem;
    }
    .qd {
      background: #E10019;
      color: #FFFFFF;
    }
    .imgcodecontent {
      background: #FFFFFF;
      padding: 0.9375rem;
      border-radius: 0.3125rem;
      width: 14.375rem;
    }
    .imgcodetitle {
      font-size: 1rem;
      color: #E10019;
    }
    .input1 {
      margin-top: 1.25rem;
    }
    .input1 input {
      width: 50%;
      height: 1.875rem;
      border: 1px solid #cccccc;
      box-sizing: border-box;
      font-size: 0.875rem;
      border-radius: 0.3125rem;
      outline: none;
      padding: 0 0.625rem;
    }
    .input1 img {
      display: block;
      width: calc(50% - 10px);
      margin-left: 10px;
    }
    .imgcodebtn {
      margin-top: 1.25rem;
      div {
        font-size: 0.75rem;
        padding: 0.3125rem 0.9375rem;
        border-radius: 0.3125rem;
        cursor: pointer;
      }
    }
  }
  .usertop {
    width: 100%;
    height: 8.125rem;
    .userimg {
      width: 5rem;
      height: 5rem;
      display: block;
      border-radius: 999px;
      margin-right: 0.625rem;
    }
    .username {
      font-size: 1.25rem;
      color: #363636;
      font-weight: bold;
      padding-bottom: 0.3125rem;
      margin-top: 0.625rem;
    }
    .uploadbtn {
      width: 4.875rem;
      height: 1.75rem;
      border: 1px solid #E10019;
      background: #FFFFFF;
      @apply flex items-center justify-center;
      color: #E10019;
      font-size: 0.9375rem;
      border-radius: 5px;
      cursor: pointer;
      box-sizing: border-box;
      margin-top: 0.3125rem;
    }
  
    .uploadbtn:hover {
      background: #E10019;
      color: #FFFFFF;
    }
  }
  .usera {
    width: 100%;
    font-size: 1.125rem;
    color: red;
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid rgb(225, 0, 25);
    cursor: pointer;
  }
  .usera:hover {
    text-decoration: underline;
  }

  .infobox {
    width: 100%;
    padding: 1.25rem;
    box-sizing: border-box;
    .userinfoitem {
      line-height: 2;
      .itemleft {
        width: 5.625rem;
        font-size: 0.9375rem;
        font-weight: bold;
        color: #363636;
      }
      .itemright {
        width: calc(100% - 5.625rem);
        font-size: 0.875rem;
        color: #363636;
      }
    }
  }
}
</style>
